import { Button } from 'hhsoig-design-system-core'
import css from './overview.module.css'
import { Divider } from '../../components/divider'
import { Link } from 'react-router-dom'
import React from 'react'
import { routePaths as routes } from '../../utilities/routePaths'

export const Report = ({ history, handler }) => {
  return (
    <div>
      <h1 className="ds-u-font-size--h2">
        Report retaliation for whistleblowing
      </h1>
      <p>
        HHS-OIG accepts and investigates complaints from whistleblowers who
        reported wrongdoing at HHS, its agencies and some non-federal employers
        and were retaliated against because of it. Our online form provides a
        secure route for whistleblowers to submit a detailed complaint about
        their experience.
      </p>
      <Divider />
      <h2 className="ds-u-font-size--h3">Before you begin</h2>
      <ul className={css.doubleSpace}>
        <li>
          You should review your eligibility for whistleblower protection from
          HHS-OIG.
        </li>
        <li>
          HHS-OIG can only accept UNCLASSIFIED complaints on this website. Do
          not disclose classified information to the HHS-OIG Hotline.
        </li>
        <li>
          You should decide if you want to disclose personal information. You
          are not required to do so, but the investigation will be impossible
          unless we can contact you.{' '}
          <Link
            to={routes.whistleblower.identity}
            onClick={() => handler('identity')}
          >
            Learn about disclosing your identity.
          </Link>
        </li>
        <li>
          You may want to consider filing your complaint with the{' '}
          <a
            href="https://osc.gov/pages/file-complaint.aspx"
            target="_blank"
            rel="noopener noreferrer"
          >
            Office of Special Counsel
          </a>
          .
        </li>
        <li>
          Be ready with a description of the retaliatory action that happened to
          you and the responsible managing official’s name.
        </li>
      </ul>
      <Button
        variation="primary"
        data-testid="create-complaint"
        onClick={() => history.push(routes.whistleblower.form)}
      >
        Start
      </Button>
      <Divider />
      <h2 className="ds-u-font-size--h3">Eligibility Criteria</h2>
      <p>
        To be eligible for whistleblower protection, you must meet the below
        criteria:
      </p>
      <ul className={css.doubleSpace}>
        <li>
          I work for HHS or one of its agencies OR I work for a non-federal
          employer, and the employer receives HHS funding.
        </li>
        <li>I’ve submitted a protected communication.</li>
        <li>
          I believe someone retaliated against me because of past whistleblower
          action I’ve taken.
        </li>
      </ul>
      <p>
        Still not sure?{' '}
        <Link
          to={routes.whistleblower.eligibility}
          onClick={() => handler('eligibility')}
        >
          Learn more about eligibility criteria.
        </Link>
      </p>
    </div>
  )
}
